import { render, staticRenderFns } from "./CalendarTermDialog.vue?vue&type=template&id=19f36ff0&scoped=true&"
import script from "./CalendarTermDialog.vue?vue&type=script&lang=js&"
export * from "./CalendarTermDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f36ff0",
  null
  
)

export default component.exports